import { render, staticRenderFns } from "./maintenrequisitionfrm.vue?vue&type=template&id=e16a79b4"
import script from "./maintenrequisitionfrm.vue?vue&type=script&lang=js"
export * from "./maintenrequisitionfrm.vue?vue&type=script&lang=js"
import style0 from "./maintenrequisitionfrm.vue?vue&type=style&index=0&id=e16a79b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports